import { Inject, Injectable } from '@angular/core';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import {
  AuthenticationResult,
  InteractionType,
  PopupRequest,
  PublicClientApplication,
  RedirectRequest,
} from '@azure/msal-browser';
import { b2cPolicies, msalConfig } from 'src/app/auth-config';

@Injectable()
export default class MsalServiceWrapper {
  b2cSignIn: PublicClientApplication;
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService
  ) {
    this.b2cSignIn = new PublicClientApplication(msalConfig);
    authService.initialize().subscribe(result => {});
  }

  async initiateFlow(flow: string) {
    await this.b2cSignIn.initialize();
    // Choose policy authority to initiate flow
    let authorityToUse = '';
    switch (flow) {
      case 'SignInSignUp':
        authorityToUse = b2cPolicies.authorities.signUpSignIn.authority;
        break;
      case 'SignUp':
        authorityToUse = b2cPolicies.authorities.signUp.authority;
        break;
      case 'ChangeSignIn':
        authorityToUse = b2cPolicies.authorities.changeSignInName.authority;
        break;
      case 'PasswordReset':
        authorityToUse = b2cPolicies.authorities.passwordReset.authority;
        break;
      default:
        authorityToUse = b2cPolicies.authorities.signUpSignIn.authority;
    }
    await this.b2cSignIn.initialize;
    this.redirect(authorityToUse);
  }

  async redirect(url: any, params = {}) {
    if (this.msalGuardConfig.interactionType === InteractionType.Redirect) {
      if (this.msalGuardConfig.authRequest) {
        void this.authService.loginRedirect({ authority: url, extraQueryParameters: params } as RedirectRequest);
      } else {
        void this.authService.loginRedirect();
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        void this.authService
          .loginPopup({ authority: url, extraQueryParameters: params } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      } else {
        void this.authService.loginPopup().subscribe((response: AuthenticationResult) => {
          this.authService.instance.setActiveAccount(response.account);
        });
      }
    }
  }
}
